/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import { frameworks, standards } from '@g17eco/core';
import { Button } from 'reactstrap';
import { DATE, formatDate, parseUserStringToDate } from '../../../utils/date';
import { DateRangeType } from '@g17eco/types/common';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';

export const isValidDate = (date?: string): date is string => {
  if (!date || date.length !== 10) {
    return false;
  }

  return parseUserStringToDate(date).isValid();
};

export const getFrameworkName = (tag: string, code: string) => {
  if (frameworks[tag]) {
    const framework = frameworks[tag];
    if (framework) {
      const subGroup = framework.subgroups?.find((f) => f.code === code);
      return `${tag.toUpperCase()} - ${subGroup ? subGroup.name : code}`;
    }
  }

  return `${tag} - ${code}`.toUpperCase();
};

export const getStandardName = (tag: string, code: string) => {
  if (standards[tag]) {
    const standard = standards[tag];
    if (standard) {
      const subGroup = standard.subgroups?.find((g) => g.code === code);
      return `${standard.name} - ${subGroup ? subGroup.name : code}`;
    }
  }

  return `${tag} - ${code}`.toUpperCase();
};

export const convertToDateParams = (dateRange: DateRangeType) => ({
  ...(dateRange.startDate && { fromDate: formatDate(dateRange.startDate, DATE.DATE_PICKER, true) }),
  ...(dateRange.endDate && { toDate: formatDate(dateRange.endDate, DATE.DATE_PICKER, true) }),
});

export const getDisplayCompleted = (completedDate: string | undefined) => (completedDate ? 'Yes' : 'No');

export const getDisplaySurveyName = (str: string, handler: () => void, maxLength: number = 15) => {
  return str.length > maxLength ? (
    <SimpleTooltip text={str}>
      <Button className='p-0 text-nowrap text-left' color='link' size='sm' onClick={handler}>
        {str.substring(0, maxLength) + '...'}
      </Button>
    </SimpleTooltip>
  ) : (
    <Button className='p-0 text-nowrap text-left' color='link' size='sm' onClick={handler}>
      {str}
    </Button>
  );
};
